export default __webpack_public_path__ + "static/media/reinventing-02.85f0a70c.jpg";